import { useEffect } from 'react';
import useGameStore from '../store/gameStore';

/**
 * Settlement toast: fired whenever an accepted (or declined) bilateral trade changes
 * cash or share ownership. Auto-dismisses, but can be closed immediately.
 */
const TradeToast = () => {
  const toast = useGameStore((s) => s.tradeToast);
  const clearTradeToast = useGameStore((s) => s.clearTradeToast);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => clearTradeToast(), 7000);
    return () => window.clearTimeout(timer);
  }, [toast, clearTradeToast]);

  if (!toast) return null;
  return (
    <div className="pointer-events-none fixed right-4 top-4 z-[70] w-[19rem] max-w-[92vw]">
      <div className="trade-toast pointer-events-auto rounded-2xl border-2 border-emerald-400/70 bg-slate-900/95 p-4 shadow-[0_16px_50px_rgba(0,0,0,0.65)]">
        <div className="flex items-start justify-between gap-2">
          <p className="text-xs font-black uppercase tracking-wider text-emerald-300">{toast.title}</p>
          <button onClick={clearTradeToast} className="rounded-lg bg-slate-800 px-2 py-0.5 text-[11px] font-bold text-slate-300 hover:bg-slate-700">
            ✕
          </button>
        </div>
        <ul className="mt-2 space-y-1 text-[12px] text-slate-200">
          {toast.lines.map((line) => (
            <li key={line} className="flex gap-1.5">
              <span className="text-emerald-400">•</span>
              <span>{line}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TradeToast;
